import React from 'react';
// import { Form } from '@ant-design/compatible';
import { SearchOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import '@ant-design/compatible/assets/index.css';
import { Table, message, Modal, Select, Button, Space, Input, Collapse } from 'antd';
import axios from 'axios';
import ENVIRONMENT from '../../../../environments'
import DeleteEntityModal from '../../DeleteEntityModal';
import SuccessModal from '../../SuccessModal/SuccessModal';
import WarningModal from '../../WarningModal/WarningModal';
import AssignArtist from '../AssignArtist/AssignArtist';
import DottedLoader from '../../DottedLoader';
const Option = { Select };
const { TextArea } = Input;
const { Panel } = Collapse;

const title = () => 'Here is title';
const showHeader = true;
const footer = () => 'Here is footer';
const scroll = { y: 240 };
const pagination = { position: 'bottom' };

class JobDeskTableScannedProducts extends React.Component {
  state = {
    bordered: false,
    loading: false,
    pagination,
    size: 'default',
    title: undefined,
    showHeader,
    footer: false,
    scroll: undefined,
    tableLayout: 'fixed',
    hasData: true,
    dataSource: null,
    unAssignActionClass: 'hide',
    assignActionClass: 'hide',
    selectedProduct: '-1',
    artists: [],
    filter_customers: [],
    filter_artists: [],
    filter_companies: [],
    filter_categories: [],
    filter_model_types: [],
    assignmentModelVisible: false,
    deleteModalVisible: false,
    deletingModelLoader: false,
    deleteSuccessModal: false,
    deleteWarningModal: false,
    parentAssignedArtist: '',
    buttonLoader: false,
    load_assigned_artist: false
  };

  handleAssign = values => {

      console.log(this.props.currentTab)
      this.setState({
        buttonLoader: true
      });
      let payload = {
        assigned_artist : values.artist_username,
        product_id: this.props.selected_id.toString(),
        admin_username: localStorage.getItem('username')
      }

      if (values.height) {
        payload.height = values.height;
      }
      if (values.width) {
        payload.width = values.width;
      }
      if (values.length) {
        payload.length = values.length;
      }

      if(values.admin_text_guidelines) {
        payload.admin_text_guidelines = values.admin_text_guidelines;
      }

      console.log('payload=', payload)
      axios.post(ENVIRONMENT.UPDATE_PRODUCT, payload)
        .then(res => {
          console.log(res);
          console.log(res.data);
          message.info('Model has been assigned to Specified Artist');
          this.setState({
            assignmentModelVisible: false,
            buttonLoader: false,
          });
          setTimeout(() => {window.location.reload();}, 1500)
            this.handleUnAssignedDataSource(); 
        })
        
  }

  delete_model = (id) =>{
    console.log('in delete product function')
    this.setState({
      deletingModelLoader: true
    })
    axios.post(
      ENVIRONMENT.DELETE_INCOMPLETE_REQUEST, {
        'entity_type': 'Product',
        'entity_id': id
      }).then(res => {
        console.log(res)
        if (res && res.data.length == 0) {
          this.setState({
            deleteWarningModal: true
          })
        } else {
          this.setState({
            deleteSuccessModal: true
          });
        }
        this.setState({
          deletingModelLoader: false,
          deleteModalVisible: false,
        });
      })
  }

  onCancelDelete = () => {
    this.setState({
      deletingModelLoader: false,
      deleteModalVisible: false
    })
  };

  handleCancel = () => {
    this.setState({
      assignmentModelVisible: false
    });
  }

  showAssignmentModal = (id, data) => {
    console.log('id=',id)
    this.setState({
      selectedProduct: id,
      assignmentModelVisible: true,
      load_assigned_artist: true,
    });
    if (data.variant_of) {
      let product_id = data.variant_of.toString();
      axios.post(ENVIRONMENT.FETCH_PRODUCT, { product_id })
      .then(res => {
        this.setState({
          parentAssignedArtist: res.data.assigned_artist,
          load_assigned_artist: false
        });
      });
    } else {
      this.setState({
        parentAssignedArtist: "",
        load_assigned_artist: false
      });
    }
    this.props.set_id(id);
    console.log('selectedProductId=', this.props.selected_id)
  }

  getColumns = () => [
    {
      title: 'Product Name',
      dataIndex: 'name',
      key: 'name',
      width: '15%',
      ...this.getColumnSearchProps('name'),
      render: text => <span>{text}</span>,
    },
    {
      title: 'Model Id',
      dataIndex: 'id',
      key: 'id',
      sorter: (a, b) => a.id - b.id,
      ...this.getColumnSearchProps('id'),
      render: text => <a onClick={() => window.open('../product_guidelines/' + text, 'Product Guidelines', "height=600,width=1000")}>{text}</a>,
    },
    {
      title: 'Category',
      dataIndex: 'category',
      key: 'category',
      filters: this.state.filter_categories,
      onFilter: (value, record) => record.category === value,
    },
    {
      title: 'Date Created',
      dataIndex: 'created_on',
      key: 'created_on',
      sorter: (a, b) => new Date(a.created_on) - new Date(b.created_on),
      render: text => <span>{text}</span>,
    },
    {
      title: 'Last Modified',
      dataIndex: 'last_modified',
      key: 'last_modified',
      sorter: (a, b) => new Date(a.last_modified) - new Date(b.last_modified),
      render: text => <span>{text}</span>,
    },
    {
      title: 'Customer',
      dataIndex: 'customer',
      key: 'customer',
      filters: this.state.filter_customers,
      onFilter: (value, record) => record.customer === value,
      render: text => <span>{text}</span>,
    },
    {
      title: 'Company',
      dataIndex: 'company',
      key: 'company',
      filters: this.state.filter_companies,
      onFilter: (value, record) => record.company === value,
      render: text => <span>{text}</span>,
    },
    {
      title: 'Assigned Artist',
      dataIndex: 'assigned_artist',
      key: 'assigned_artist',
      filters: this.state.filter_artists,
      onFilter: (value, record) => record.assigned_artist === value,
    },
    {
      title: 'Action',
      key: 'action',
      className: this.state.unAssignActionClass,
      render: (text, record) => (
        <span>
          <a onClick={() => this.unAssignProductConfirm(record.product_id, record.assigned_artist)}>UnAssign</a>
        </span>
      ),
    },
    {
      title: 'Action',
      key: 'assign_action',
      className: this.state.assignActionClass,
      render: (text, record) => (
        <span>
          <a onClick={() => this.showAssignmentModal(record.id, record)}>Assign to Artist</a>
        </span>
      ),
    },
    this.props.delete_model ? {
      title: 'Action',
      key: 'delete_model',
      className: 'delete-model',
      render: (text, record) => (
        <span>
          <a onClick={() => this.setState({
            selected_id: record.id,
            deleteModalVisible: record.model_status == -4 ? false : true,
            deleteWarningModal: record.model_status == -4 ? true : false
          })}>Delete</a>
        </span>
      ),
    } :{}
  ];

  unAssignProductConfirm(product_id, assigned_artist) {
    Modal.confirm({
      title: 'Are you sure you want to unassign this product?',
      icon: <ExclamationCircleOutlined />,
      content: 'Artist might have already started working on it.',
      onOk: () => {
        console.log('OK');
        this.unAssignProduct(product_id, assigned_artist);
      },
      onCancel() {
      },
    });
  }


  // Search in table functionality
  getColumnSearchProps = dataIndex => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={node => {
            this.searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ marginBottom: 8, display: 'block' }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{ width: 90 }}>
            Reset
          </Button>
        </Space>
      </div>
    ),
    filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
        : '',
    onFilterDropdownVisibleChange: visible => {
      if (visible) {
        setTimeout(() => this.searchInput.select(), 100);
      }
    }
  });

  handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    this.setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex,
    });
  };

  handleReset = clearFilters => {
    clearFilters();
    this.setState({ searchText: '' });
  };


  unAssignProduct = (product_id, assigned_artist) => {
    axios.post(ENVIRONMENT.ASSIGN_PRODUCT_MODEL, {
      assigned_artist: '',
      product_id: product_id,
      original_artist: assigned_artist,
      admin_username: localStorage.getItem('username')
    })
      .then(res => {
        console.log(res);
        console.log(res.data);
        message.info('Product has been unassigned.');
        setTimeout(() => {window.location.reload();}, 1500)
        this.handleAssignedDataSource(2);
        this.handleUnAssignedDataSource();
      })
  }

  loadArtistsData = () => {

    axios.post(ENVIRONMENT.ARTIST_PROFILE_LIST, {
    })
      .then(res => {
        console.log(res.data)
        let artist_list = [];
        res.data.map(artist => {
          if (artist.is_active == true || artist.is_active == "True") {
            artist_list.push(artist);
          }
        });
        this.setState({
          artists: artist_list
        });
      });
  }

  componentDidMount = () => {
    console.log('props.state = ', this.props.state)
    if (this.props.state == 'assigned_not_modeled') {
      this.setState({
        unAssignActionClass: ''
      });
      this.handleAssignedDataSource(2);
    }
    if (this.props.state == 'assigned_modeled') {
      this.setState({
        unAssignActionClass: 'hide',
      });
      this.handleAssignedDataSource(3);
    }
    if (this.props.state == 'unassigned') {
      this.loadArtistsData();
      this.setState({
        unAssignActionClass: 'hide',
        assignActionClass: '',
      });
      this.handleUnAssignedDataSource();
    }
  }

  handleFilteringOptions = (filter_categories_values, filter_customer_values, filter_company_values, filter_artist_values, filter_model_type_values) => {
    
    let filter_categories_objects = [];
    let filter_customer_objects = [];
    let filter_company_objects = [];
    let filter_artist_objects = [];
    let filter_model_type_objects = [];

    filter_categories_values.sort(function(a , b){
      return (a.toLowerCase() > b.toLowerCase()) ? 1:-1
    });
    filter_customer_values.sort(function(a , b){
      return (a.toLowerCase() > b.toLowerCase()) ? 1:-1
    });
    filter_company_values.sort(function(a , b){
      return (a.toLowerCase() > b.toLowerCase()) ? 1:-1
    });
    filter_artist_values.sort(function(a , b){
      return (a.toLowerCase() > b.toLowerCase()) ? 1:-1
    });
    filter_model_type_values.sort(function(a , b){
      return (a.toLowerCase() > b.toLowerCase()) ? 1:-1
    });


    filter_categories_values.forEach( filter_categories_value => {
      filter_categories_objects.push({
        text: filter_categories_value,
        value: filter_categories_value,
      })
    });

    filter_customer_values.forEach( filter_customer_value => {
      filter_customer_objects.push({
        text: filter_customer_value,
        value: filter_customer_value,
      })
    });

    filter_company_values.forEach( filter_company_value => {
      filter_company_objects.push({
        text: filter_company_value,
        value: filter_company_value,
      })
    });
    filter_artist_values.forEach( filter_artist_value => {
      filter_artist_objects.push({
        text: filter_artist_value,
        value: filter_artist_value,
      })
    });
    filter_model_type_values.forEach( filter_model_type_value => {
      filter_model_type_objects.push({
        text: filter_model_type_value,
        value: filter_model_type_value,
      })
    });

    this.setState({
      filter_categories: filter_categories_objects,
      filter_customers: filter_customer_objects,
      filter_companies: filter_company_objects,
      filter_artists: filter_artist_objects,
      filter_model_type: filter_model_type_objects
    });

  }

  create_dic = (data, model_status, i) => {
    let res = {};
    res = {
      key: i,
      product_id: data['id'],
      name: data['name'],
      id: data['id'],
      category: data['category'],
      customer: data['customer_username'],
      company: data['company_name'],
      created_on: data['created_on'],
      last_modified: data['last_modified'],
      model_status: data['model_status'],
      variant_of: data['variant_of'],
    }

    return res;
  }

  getPayload = () => {
    return {
      "required_fields": ["id","name","brand_id", "created_on","last_modified","category", "company_name", "model_type", 
      "model_type","need_to_model", "assigned_artist","customer_username", 
      "group_id", "uploaded_model", "variant_of", "variation_type", "segmented",
      "hidden_from_artist", "model_status", "subscription_display_name", "last_modified_stamp"],
      "order_by": "last_modified_stamp desc"
    }
  }

  handleAssignedDataSource = (model_status) => {
    let data = [];
    this.setState({
      loading: true
    })
    let payload = this.getPayload();
    payload['filter_string'] =  "(model_status__in=["+ model_status + "]&&scans__isnull=false&&uploaded_model__is=false)"

    axios.post(ENVIRONMENT.LIST_PRODUCT, payload)
      .then(res => {
        console.log(res.data)
        for (let i = 1; i <= (res.data).length; i++) {
          //following check will be removed when we have this filter availale on API side
          if (res.data[i - 1]['assigned_artist'] != '') {     
            data.push(this.create_dic(res.data[i - 1], model_status, i));
          }
        }
        data.sort((a,b) => {
          return b.product_id - a.product_id
        })
        this.setState({
          dataSource: data
        })
        this.populate_filtering_data(data)
        this.setState({
          loading: false
        })
      });
  }

  populate_filtering_data = (data) => {
    let filter_categories_values = [];
    let filter_customer_values = [];
    let filter_company_values = [];
    let filter_artist_values = [];
    let filter_model_type_values = ['plain', 'patterned'];

    for(let i = 1; i <= (data).length; i++){
      let category_value = data[i - 1]['category'];
      if(category_value != "" && !filter_categories_values.includes(category_value)){
        filter_categories_values.push(category_value);
      }

      let customer_value = data[i - 1]['customer'];
      if(customer_value != "" && !filter_customer_values.includes(customer_value)){
        filter_customer_values.push(customer_value);
      }

      let company_value = data[i - 1]['company'];
      if(company_value != "" && !filter_company_values.includes(company_value)){
        filter_company_values.push(company_value);
      }

      let artist_value = data[i - 1]['assigned_artist']
      if(artist_value != "" && !filter_artist_values.includes(artist_value)){
        filter_artist_values.push(artist_value)
      }
    }

    this.handleFilteringOptions(filter_categories_values, filter_customer_values, filter_company_values, filter_artist_values, filter_model_type_values)
  }

  handleUnAssignedDataSource = () => {
    this.setState({
      loading: true
    })
    let data = [];
    let payload = this.getPayload();
    payload['filter_string'] =  "(model_status__in=[2,-4]&&scans__isnull=false&&uploaded_model__is=false)"
    
    axios.post(ENVIRONMENT.LIST_PRODUCT, payload)
      .then(res => {
        for (let i = 1; i <= (res.data).length; i++) {
          //following check will be removed when we have this filter availale on API side
          if (res.data[i - 1]['assigned_artist'] == '') {
            data.push(this.create_dic(res.data[i - 1], 2, i));
          }
        }
        data.sort((a,b) => {
          return b.product_id - a.product_id
        })
        this.setState({
          dataSource: data
        })
        this.populate_filtering_data(data);
        this.setState({
          loading: false
        })
      });
  }

  handleToggle = prop => enable => {
    this.setState({ [prop]: enable });
  };

  handleSizeChange = e => {
    this.setState({ size: e.target.value });
  };

  handleTitleChange = enable => {
    this.setState({ title: enable ? title : undefined });
  };

  handleHeaderChange = enable => {
    this.setState({ showHeader: enable ? showHeader : false });
  };

  handleFooterChange = enable => {
    this.setState({ footer: enable ? footer : undefined });
  };

  handleRowSelectionChange = enable => {
    this.setState({ rowSelection: enable ? {} : undefined });
  };

  handleScollChange = enable => {
    this.setState({ scroll: enable ? scroll : undefined });
  };

  handleDataChange = hasData => {
    this.setState({ hasData });
  };

  handlePaginationChange = e => {
    const { value } = e.target;
    this.setState({
      pagination: value === 'none' ? false : { position: value },
    });
  };

  render() {
    const { state } = this;
    const { dataSource } = state;

    return (
      <div>
        {this.state.loading ?
        <DottedLoader/> :
          dataSource &&
          <Table {...this.state} columns={this.getColumns()} dataSource={dataSource} />
        }
        <DeleteEntityModal
        onCancel={this.onCancelDelete}
        visible={this.state.deleteModalVisible}
        deletingModelLoader={this.state.deletingModelLoader}
        selected_id={this.state.selected_id}
        delete_model={this.delete_model}
        heading={'You are about to delete a Product'}
        subText={'Once deleted, it cannot be recovered. Are you sure you want to delete it?'}
        />
        <SuccessModal
         visible={this.state.deleteSuccessModal}
         heading={"Product Deleted Successfully!"}
         text={"The product has been deleted successfully."}
         footer={[
            <div className="justify-in-center">
                <Button style={{margin:"auto"}} className="modal-okay square font-14" htmlType="submit" onClick={() => {
                    window.location.reload();}}>
                    Okay
                </Button>
            </div>
         ]}/>
        <WarningModal
        visible={this.state.deleteWarningModal}
        onCancel={() => this.setState({ deleteWarningModal: false })}
        heading={"Oops! You cannot delete this product."}
        text={"This product cannot be deleted directly since it has assets and information associated with it. Please contact the engineering team to get it removed."}
        footer={[
            <div className="justify-in-end">
                <Button key="back" style={{textAlign:"center"}} className="modal-okay square font-14" onClick={() => this.setState({ deleteWarningModal: false })}>
                    Okay
                </Button>
            </div>
        ]}
        />

        <AssignArtist
        entity={"product"}
        parentAssignedArtist={this.state.parentAssignedArtist}
        handleCancel={this.handleCancel}
        handleAssign={this.handleAssign}
        artists={this.state.artists}
        buttonLoader={this.state.buttonLoader}
        load_assigned_artist={this.state.load_assigned_artist}
        assignmentModelVisible={this.state.assignmentModelVisible}
        />
      </div>
    );
  }
}

export default JobDeskTableScannedProducts;
